import { render, staticRenderFns } from "./accountsDeposit.vue?vue&type=template&id=561df932"
import script from "./accountsDeposit.vue?vue&type=script&lang=js"
export * from "./accountsDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports